import { pageId } from "~/utils/pageId";

export default () => ({
    projectGroup: {
        root: pageId({ area: "Project", id: "ProjectGroup.Edit", name: "Project Group", routeLink: null }),
    },
});
